<div class="w-full h-screen flex items-center relative">
  <div class="w-full flex flex-col items-center py-16">
    <div class=" flex flex-col w-full items-center justify-center">
      <img alt="Logo" class="h-16" src="/assets/images/logo-blue.svg" />
      <span [title]="appVersion" class="text-neutral-400 text-2xl font-bold mt-2">{{ appName }}</span>
    </div>
    <div class="w-[30%] mt-12">
      @if (isShowNewPasswordForm) {
        <div>
          <app-new-password-form (submitSuccessEvent)="onSubmitSuccess($event)"></app-new-password-form>
        </div>
      }
      @if (isShowMessageBox) {
        <div>
          <app-message-box [isValidToken]="isValidToken" [isSubmitSuccess]="isSubmitSuccess"></app-message-box>
        </div>
      }
    </div>
  </div>
</div>
